import {  Component,  OnInit } from '@angular/core';
import {  BookResult } from 'src/app/models/api_models/book';
import {  BookService } from 'src/app/api/book.service';
import {  UserApiService } from 'src/app/user-api.service';
import {  UserApi } from 'src/app/models/api_models/user';
import {  ServiceInfo } from 'src/app/models/display/serviceInfo';


@Component({
  selector: 'app-book-list-page',
  templateUrl: './book-list-page.component.html',
  styleUrls: ['./book-list-page.component.scss']
})
export class BookListPageComponent implements OnInit {

  public book: BookResult = null;

  private _bookList: [BookService[]] = [null];
  get bookList(): [BookService[]] { return this._bookList; };
  set bookList(bookList: [BookService[]]) { this._bookList = bookList };

  private _currentUser: UserApi = null;
  get currentUser(): UserApi { return this._currentUser; };
  set currentUser(currentUser: UserApi) { this._currentUser = currentUser };

  private _isUserLoad: boolean = false;
  get isUserLoad(): boolean { return this._isUserLoad; }
  set isUserLoad(isUserLoad: boolean) { this._isUserLoad = isUserLoad; }

  private _servicesList: ServiceInfo[] = [];
  get servicesList(): ServiceInfo[] { return this._servicesList; }
  set servicesList(servicesList: ServiceInfo[]) { this._servicesList = servicesList; }


  private _serviceSelected: string = "autopartage";
  get serviceSelected(): string { return this._serviceSelected; }
  set serviceSelected(serviceSelected: string) { this._serviceSelected = serviceSelected; }

  public oldLoaded: boolean = false;
  public nextLoaded: boolean = false;


  setServiceSelected(service: string) {
    this._serviceSelected = service;
  }

  constructor(private bookService: BookService, private userApiService: UserApiService) { }

  // private convertDateFormat(dateStr: string) {
  //   let date = new Date(dateStr);
  //   // todo  probleme de date   a revoir quand l api sera prete 
  //   date.setTime(date.getTime() - (2000 * 3600));
  //   return date.toISOString();
  // }



  private convertService(book: BookResult): BookResult {
    if (book.type == 0) {
      book.type = 1;
    } else if (book.type == 1) {
      book.type = 0;
    } else {
      book.type = -1;
    }
    return book;
  }

  getDateFormat(str : string){
    var newString = str.replace('-','/').replace('-', '/').replace('T',' ').replace(':00Z','');
   return  newString
  }

   getKey(book: BookResult): string {

    let currentDate = new Date()
    let endDate = new Date(this.getDateFormat(book.enddate))
    let startdate = new Date(this.getDateFormat(book.startdate))
    console.log(book)
  //    console.log(" gggg")
    if (currentDate > startdate && currentDate < endDate) {
      // console.log("now")
      // console.log(startdate)
      return "now";
    } else if (currentDate > endDate) {
      // console.log("last")
      // console.log(startdate)
      return "last";
    } else {
      // console.log("next")
      // console.log(startdate)
      return "next";
    }
  }

  ngOnInit() {
    this.userApiService.getCurrentUserData().subscribe(
      response => {
        if (response != undefined) {
          this._currentUser = response;

          this._isUserLoad = true;
          this._servicesList = this._currentUser.getUserServices();
        }
      });
    this.bookService.getBooks().subscribe(
      response => {
        console.log(response.length)
        for (let book of response) {
         // book = this.convertService(book);
          if (book.type >= 0) {

            // book.startdate = this.convertDateFormat(book.startdate);
          //  console.log(book.startdate)
            // book.enddate = this.convertDateFormat(book.enddate);
            if (this._bookList[this.getKey(book)] == null) {
              this._bookList[this.getKey(book)] = [book];
            } else {
              this._bookList[this.getKey(book)].push(book);
            }
          }
        }
        this.oldLoaded = true;
        this.nextLoaded = true;

      },
      error => {


      }
    );
  }

}
